import React, { Component } from 'react'
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class CoverPage extends Component {
  render() {
    return (
        	<div class="container">
		<div class="row justify-content-center">
			<div class="col-0">
			</div>
			<div class="col-10 col-sm-10 col-md-9 col-lg-8 col-xl-6">
				<img class="cover_logo" src="https://i.ibb.co/gMXwTGG/slice1-3x.png" alt="slice1-3x" border="0"/>
			</div>
			<div class="col-0">
			</div>
		</div>

		<div class="row">
			<div class="col">
			</div>
			<div class="col-10 col-sm-10 col-md-9 col-lg-8 col-xl-6 cover_title" >
				<p class="text_beginner">Getting Started</p>
				<p class="text_guide">Guide</p>

			</div>
			<div class="col">
			</div>
	</div>

	    <div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                  <MDBNavLink class="nav-link" to="/WhatIs">
                     <a href="#" class="Bottom_button">
                     <p>What is Daily24?</p>
                     </a>
                  </MDBNavLink>
            </div>
			<div class="col"></div>


		</div>

	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CoverPage.js